const server =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:8000/api/v1"
    : "https://urbanbazaarpune.in/api/v1");

export const EstoreBaseUrl = "https://estore.searchintech.in/api/v1";
export default server;
